import { ChecklistStyles } from "../../utils/styles"

let vs = ChecklistStyles()
const Selector = ({ setScreen = () => { }, screen }) => {
  let ChecklistStyles = vs()

  const change = (ventana) => {
    setScreen(ventana)
  }

  return (
    <div className={ChecklistStyles.selectionContainer}>
      <div className={ChecklistStyles.buttonArea}>
        <button
          onClick={(e) => change("OrdenServicio")}
          className={
            screen === "OrdenServicio"
              ? ChecklistStyles.buttonFocus
              : ChecklistStyles.button
          }
        >
          Orden de Servicio por Unidad
        </button>
      </div>
      <div className={ChecklistStyles.buttonArea}>
        <button
          onClick={(e) => change("AvanceOrdenServicio")}
          className={
            screen === "AvanceOrdenServicio"
              ? ChecklistStyles.buttonFocus
              : ChecklistStyles.button
          }
        >
          Avance Orden Servicio
        </button>
      </div>
      <div className={ChecklistStyles.buttonArea}>
        <button
          onClick={(e) => change("EficienciaMecanicos")}
          className={
            screen === "EficienciaMecanicos"
              ? ChecklistStyles.buttonFocus
              : ChecklistStyles.button
          }
        >
          Eficiencia Mecánicos
        </button>
      </div>
      <div className={ChecklistStyles.buttonArea}>
        <button
          onClick={(e) => change("FrecuenciaVisitas")}
          className={
            screen === "FrecuenciaVisitas"
              ? ChecklistStyles.buttonFocus
              : ChecklistStyles.button
          }
        >
          Frecuencia de Entradas (Ingresos)
        </button>
      </div>
      <div className={ChecklistStyles.buttonArea}>
        <button
          onClick={(e) => change("ConsumoRefacciones")}
          className={
            screen === "ConsumoRefacciones"
              ? ChecklistStyles.buttonFocus
              : ChecklistStyles.button
          }
        >
          Consumo de Refacciones
        </button>
      </div>
    </div>
  )
}
export default Selector
